
import { Component, Prop, Watch, toNative, Vue } from 'vue-facing-decorator';
import NotificationPopup from '@/components/Common/NotificationPopup.vue';
import { ApplicationViewModel } from '@/entities/Application/ApplicationViewModel';
import { NavBarImages } from '@/entities/Application/NavBarImages';
import ModuleTypeEnum from '@/enums/ModuleTypeEnum';
import { EventSideMenu } from '@/entities/Application/EventSideMenu';
import { AppNavBarImages } from '@/entities/Application/AppNavBarImages';
import { ApplicationSideMenu } from '@/entities/Application/ApplicationSideMenu';
import { LeftMenuModel } from '@/entities/Application/LeftMenuModel';

@Component({
  components: {
    NotificationPopup,
  },
})
class LeftMenuPanel extends Vue {
  @Prop() viewModel!: ApplicationViewModel;
  @Prop() showLeftMenuBar!: boolean;
  @Prop() menuItems!: EventSideMenu | ApplicationSideMenu;
  @Prop() iconImages!: NavBarImages | AppNavBarImages;
  @Prop() activeComponent!: string;
  private IconFile: string = require('@/assets/Images/VentlaLogo/Ventla-Logo-Grey.svg');
  private currentYear: number = new Date().getUTCFullYear();
  private expandedItems: Record<string, boolean> = {};

  public get routeParams() {
    return {
      applicationborderColor: this.viewModel.ApplicationInformation.TopNavBackgroundColor,
      applicationId: this.viewModel.ApplicationInformation.Id,
      applicationInstanceId: this.viewModel.ActiveEvent.Id,
    };
  }

  public get selectedComponent(): typeof ModuleTypeEnum {
    return ModuleTypeEnum;
  }

  @Watch('activeComponent', { immediate: true })
  private onActiveComponentChanged() {
    // Auto-expand collapsible sections when navigating to one of their sub-items
    for (const item of this.menuItems.MenuItems) {
      if (this.hasSubItems(item) && this.isSubItemActive(item)) {
        this.expandedItems = { ...this.expandedItems, [item.Id]: true };
      }
    }
  }

  private hasSubItems(item: LeftMenuModel): boolean {
    return !!item.SubItems && item.SubItems.length > 0;
  }

  private isSubItemActive(item: LeftMenuModel): boolean {
    return !!item.SubItems && item.SubItems.some((sub) => sub.ComponentName === this.activeComponent);
  }

  private toggleExpand(itemId: string) {
    this.expandedItems = { ...this.expandedItems, [itemId]: !this.expandedItems[itemId] };
  }

  private GetImageSrc(id: number, isActive: boolean) {
    return isActive ? this.iconImages.NavBarImage[id].ActiveImageSrc : this.iconImages.NavBarImage[id].ImageSrc;
  }

  // Helper to ensure external URLs are formatted correctly
  private GetFullExternalUrl(url: string) {
    if (!url) {
      return 'javascript:void(0)';
    }
    // Prepend Environment URL if it's a relative path
    const baseUrl = (this as any).$EnvironmentBaseURL;
    return url.startsWith('http') ? url : baseUrl + url;
  }

}
export default toNative(LeftMenuPanel);

